var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4384,
    cy: 20.4384,
    r: 20.4384,
    fill: "#059DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87695 28.4385V22.8202L20.1561 12.4385L30.877 22.2095V28.4385L20.1561 18.3011L8.87695 28.4385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollUp);
export default __webpack_public_path__ + "static/media/scrollUp.0132fcc5caa29e3320c56bb2918350ef.svg";
export { ForwardRef as ReactComponent };